import { render, staticRenderFns } from "./AddVitals.vue?vue&type=template&id=f0499ada&"
import script from "./AddVitals.vue?vue&type=script&lang=js&"
export * from "./AddVitals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports